import React from 'react';
import { Image, Video } from 'lucide-react';
interface MediaPlaceholderProps {
  type: 'image' | 'video';
  className?: string;
  text?: string;
}
export function MediaPlaceholder({
  type,
  className = '',
  text
}: MediaPlaceholderProps) {
  return <div className={`flex flex-col items-center justify-center bg-brand-gray border-2 border-dashed border-gray-600 rounded-lg p-6 text-gray-400 ${className}`} data-id="element-75">
      {type === 'image' ? <Image className="w-12 h-12 mb-2 opacity-50" data-id="element-76" /> : <Video className="w-12 h-12 mb-2 opacity-50" data-id="element-77" />}
      <span className="text-sm font-medium text-center" data-id="element-78">
        {text || `[Reemplazar con tu ${type === 'image' ? 'Imagen' : 'Video'}]`}
      </span>
      <span className="text-xs mt-1 opacity-70 text-center" data-id="element-79">
        Edita el código para insertar la URL de tu asset aquí
      </span>
    </div>;
}